import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import styles from './StatementAcknowledgmentDialog.styles.scss';
import cn from 'classnames';

const StatementAcknowledgmentDialog = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={cn('rounded-4 overflow-hidden', styles.acknowledgmentDialog)}
      visible={isOpen}
      onHide={() => setIsOpen(false)}
    >
      <p>{t('invoice_statement.acknowledgment_text')}</p>
    </Dialog>
  );
};

export default React.memo(StatementAcknowledgmentDialog);
